module.exports = __webpack_public_path__ + "static/tube-mobile@2x-3b6deb9a74a227472bac12c80eaa5644.png";